<template>
  <el-col :span="20" :xs="24" class="redesign">
    <el-card>
      <template #header>
        <h3>Start buying premium adult traffic with CPM & CPC</h3>
        <p class="text-muted">
          Follow the checklist below. One step at a time.
        </p>
      </template>
      <OnboardingSteps :active-step="step" />
    </el-card>
    <DirectFaq />
  </el-col>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import OnboardingSteps from './onboarding/OnboardingSteps.vue'
import DirectFaq from './DirectFaq.vue'

export default defineComponent({
  name: 'Onboarding',
  components: {
    OnboardingSteps,
    DirectFaq
  },
  props: {
    step: {
      type: Number,
      default: 0
    }
  },
  setup(props) {}
})
</script>
<style lang="scss" scoped>
.el-card {
  border-radius: 0.75em;
  h3 {
    font-size: 30px;
    margin: 0;
  }
  p {
    font-size: 16px;
    margin: 0;
    margin-top: 6px;
  }
  :deep(.el-card__header) {
    border: none;
  }
}
</style>
